// extracted by mini-css-extract-plugin
module.exports = {"container":"Banner_container__2FScR","link":"Banner_link__3Lsb3","banner":"Banner_banner__3CZ0d","inner":"Banner_inner__3I4w8"};